<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>
    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListSubscriptions" [ttBadge]="'badge'"></tt-list>
</tt-page>
